import {TAG_ROUTES as tagRoutes} from "~/api/routes";
import {PACK_ROUTES as packRoutes} from "~/api/routes";

export const state = () => ({
  tags: [],
  details: null,
});
export const getters = {};
export const mutations = {
  TAGS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.tags = [];
    //state.page = page;
  },
  TAG_SUCCES(state, tags) {
    state.tags = tags;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  TAGS_ERROR(state) {
    state.tags = [];
    state.hasError = true;
  },
  TAGS_LOADED(state) {
    //state.isLoading = false;
  },
  TAG_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  TAG_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  TAG_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_TAG(state, tag) {
    let index = state.tags.findIndex((elem) => elem.tag_id === tag.tag_id);
    state.tags = state.tags.filter(element => element.tag_id !== tag.tag_id);
    state.tags.splice(index, 0, tag);
  },
  TAG_DETAILS_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
  ADD_TAG_TO_LIST(state, tag) {
    state.tags.push(tag);
  },
  REMOVE_TAG_TO_LIST(state, tag) {
    state.tags = state.tags.filter(element => element.tag_id !== tag.tag_id);
  },
};
export const actions = {
  async getTags({commit}) {
    commit('TAGS_LOAD');
    this.$api.request(tagRoutes.list)
      .then(response => {
        commit('TAG_SUCCES', response.payload);
      })
      .catch(error => {
        commit('TAGS_ERROR');
      })
      .finally(() => commit('TAGS_LOADED'));
  },
  async createTag({commit}, params) {
    commit('TAG_PROCESSING_START');
    await this.$api.request(tagRoutes.create, {}, params)
      .then(response => {
        //commit('TAG_SUCCES', response);
        commit('ADD_TAG_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('TAG_ERROR');
      })
      .finally(() => commit('TAG_PROCESSING_END'));
  },
  async updateTag({commit}, params) {
    commit('TAG_PROCESSING_START');
    await this.$api.request(tagRoutes.update, {id: params.id}, params)
      .then(response => {
        //commit('TAG_SUCCES', response);
        commit('UPDATE_A_TAG', response.payload);
      })
      .catch(error => {
        commit('TAG_ERROR');
      })
      .finally(() => commit('TAG_PROCESSING_END'));
  },
  async deleteTag({commit}, params) {
    commit('TAG_PROCESSING_START');
    await this.$api.request(tagRoutes.delete, {id: params.tag_id})
      .then(response => {
        //commit('TAG_SUCCES', response);
        commit('REMOVE_TAG_TO_LIST', params);
      })
      .catch(error => {
        commit('TAG_ERROR');
      })
      .finally(() => commit('TAG_PROCESSING_END'));
  },
  async getTag({commit}, params) {
    commit('TAG_PROCESSING_START');
    await this.$api.request(tagRoutes.get, {id: params.tag_id})
      .then(response => {
        commit('TAG_DETAILS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('TAG_ERROR');
      })
      .finally(() => commit('TAG_PROCESSING_END'));
  },
};
